exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#cardLogin{width:30%;margin:0 auto;position:absolute;top:25%;left:50%;transform:translate(-50%,-50%)}.error-msg{color:red;font-size:14px}h1{font-size:3em!important}.input,.mt-3.mb-3{font-size:1.5em!important}.remember{height:10px;width:200px;vertical-align:middle}.card-logo{position:absolute;top:10px;right:10px}body{background-color:#3d8cbc!important}.loading-box{color:#333}.loading-box,.message-box{font-size:18px;text-align:center;margin-top:20px}.message-box{padding:15px;border-radius:5px}.success{background-color:#dff2bf;color:#4f8a10}.failure{background-color:#ffd2d2;color:#d8000c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/login/Recover.vue?vue&type=style&index=0&id=9888159a&prod&lang=css&
// module id = 951
// module chunks = 0